 export const mstatus = [
    { code: 'DI', label: 'Divorced' },
    { code: 'MA', label: 'Married' },
    { code: 'SE', label: 'Separated' },
    { code: 'SI', label: 'Single' },
    { code: 'WI', label: 'Widowed' }, 
  ];
  